import { render, staticRenderFns } from "./GoodbyeMessage.vue?vue&type=template&id=57437426&scoped=true&"
import script from "./GoodbyeMessage.vue?vue&type=script&lang=js&"
export * from "./GoodbyeMessage.vue?vue&type=script&lang=js&"
import style0 from "./GoodbyeMessage.vue?vue&type=style&index=0&id=57437426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57437426",
  null
  
)

export default component.exports